import useSWR from 'swr'
import { NextSeo } from 'next-seo'
import { Container } from '@/features/global/components/Layout/Container'
import { useBreadcrumb } from '@/hooks/useBreadcrumb'
import { H1 } from '@/components/label/H1'
import { GetFeatureListResponse } from '@/types/feature'
import { isErrorResponse } from '@/types/error'
import { useRouter } from 'next/router'
import { QueryParams } from './types'
import { Pagination } from '@/components/button/Pagination'
import { FeaturesL } from '../Feature/FeaturesL'
import { SkeltonView } from '.'

export const DiagnosisListPage: React.FC = () => {
  const router = useRouter()
  const query = router.query as QueryParams
  const { page = 1 } = router.query

  useBreadcrumb([
    {
      name: 'おすすめ要約診断',
    },
  ])

  const { data, error } = useSWR<GetFeatureListResponse>(
    `/api/feature/diagnosis?page=${page}&limit=24`
  )

  /**
   * ページネーションクリック時
   */
  const onPageChange = (selectedItem: { selected: number }) => {
    router.push({
      pathname: `/diagnosis/list/${selectedItem.selected + 1}`,
    })
  }

  /**
   * ページネーションの数を取得
   */
  const getPageCount = (): number => {
    if (isErrorResponse(data)) {
      return 1
    }
    return Math.ceil(data?.total / 24)
  }

  return (
    <Container sidebar={{ pc: true, sp: true }}>
      <NextSeo
        title="おすすめ要約診断 | 本の要約サイト flier(フライヤー)"
        canonical={`${process.env.WWW_SERVER}/diagnosis/list`}
        noindex={Number(page) > 1}
        openGraph={{
          url: `${process.env.WWW_SERVER}/diagnosis/list`,
        }}
      />
      <div className="pb-12 mb-12 main">
        <div className="pt-5 sm:pt-10 pb-6 text-center">
          <H1 title="おすすめ要約診断" />
        </div>
        {!data ? (
          <SkeltonView />
        ) : error || isErrorResponse(data) || !data?.result ? (
          <div>データの取得に失敗しました</div>
        ) : (
          <>
            <FeaturesL features={data.features} column={4} />
            <Pagination
              forcePage={query.page ? parseInt(query.page) - 1 : 0}
              pageCount={getPageCount()}
              onPageChange={onPageChange}
            />
          </>
        )}
      </div>
    </Container>
  )
}
